<div *ngIf="formGroup"
     id="languageForm"
     [formGroup]="formGroup"
     class="flex flexJustify-between flexAlign-center">

    <!-- Preferred Language (single select) -->
    <mat-form-field class="col col--050">
      <mat-label>Preferred Language</mat-label>
      <mat-select formControlName="preferredLanguage">
        <mat-select-trigger>
          {{ getLanguageDisplay(formGroup.controls.preferredLanguage.value) }}
        </mat-select-trigger>
        <mat-option>
          <ngx-mat-select-search [formControl]="preferredLanguageFilterCtrl" placeholderLabel="Search..."
          noEntriesFoundLabel="No Results...">
              <mat-icon  ngxMatSelectSearchClear fontSet="fal"
                        fontIcon="fa-times"></mat-icon>
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let lang of filteredPreferredLanguages | async"
                    [value]="lang.value">
          {{ lang.text }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Spoken Languages (multi-select) -->
    <mat-form-field class="col col--050">
      <mat-label>Spoken Languages</mat-label>
      <mat-select formControlName="entityLanguages" multiple>
        <mat-select-trigger>
          {{ getLanguageSelectionDisplay(formGroup.controls.entityLanguages.value) }}
        </mat-select-trigger>
        <mat-option>
          <ngx-mat-select-search [formControl]="languageFilterCtrl" placeholderLabel="Search..."
          noEntriesFoundLabel="No Results..." [alwaysRestoreSelectedOptionsMulti]="true">
              <mat-icon  ngxMatSelectSearchClear fontSet="fal"
                        fontIcon="fa-times"></mat-icon>
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let lang of filteredLanguages | async"
                    [value]="lang.value"
                    [disabled]="formGroup.controls.preferredLanguage.value === lang.value">
          {{ lang.text }}
        </mat-option>
      </mat-select>
    </mat-form-field>

</div>
